// extracted by mini-css-extract-plugin
export var container = "_9s-0";
export var icon = "_9s-1";
export var text = "_9s-2";